import React from "react";
import {Link} from "gatsby";

type Props = {
    fixed:boolean
}

export const Footer: React.FunctionComponent<Props> = ({fixed}) => {

    return (
        <footer className={"w-full p-4 text-sm border-t border-gray-200 z-30 bg-white tablet:hidden "}>
            <ul className="flex justify-center gap-8">
                <li><Link to="/">トップ</Link></li>
                <li><a href="https://www.cammacs.jp/">キャムマックス製品ページ</a></li>
                <li><a href="https://www.cam-net.co.jp/" target="_blank">株式会社キャム</a></li>
                <li><Link to="/contact/">お問い合わせ</Link></li>
            </ul>
            <p className="text-right text-gray-400">© 2022 CAM Corporation.</p>
        </footer>
    )
}